import type { SortOption } from '~/modules/magazine/type/filter-states';
import { NewsletterTypeEnum } from 'generated/graphql';

/**
 * Sorts magazine filter options alphabetically
 */
const sortMagazineOptions = (options: SortOption[]): SortOption[] => {
    return [...options].sort((a, b) => {
        // "All" always comes first
        if (a.key === 'all') return -1;
        if (b.key === 'all') return 1;

        // "Misc." always comes last if exists
        if (a.key === 'misc') return 1;
        if (b.key === 'misc') return -1;

        // Everything else sorted alphabetically by label
        return a.label.localeCompare(b.label);
    });
};

const unsortedOptions: SortOption[] = [
    { key: 'all', label: 'All' },
    {
        key: 'build',
        label: 'Build',
        searchEnum: NewsletterTypeEnum.Build,
    },
    {
        key: 'curated',
        label: 'Curated Collection',
        searchEnum: NewsletterTypeEnum.CuratedCollection,
    },
    {
        key: 'projectfeature',
        label: 'Project of the Month',
        searchEnum: NewsletterTypeEnum.ProjectFeature,
    },
    {
        key: 'projectportfolio',
        label: 'The Project Portfolio',
        searchEnum: NewsletterTypeEnum.ProjectPortfolio,
    },
    {
        key: 'archiprostalk',
        label: `ArchiPro's Talk`,
        searchEnum: NewsletterTypeEnum.ArchiPros,
    },
    {
        key: 'commercialedit',
        label: 'The Commercial Edit',
        searchEnum: NewsletterTypeEnum.CommercialEdit,
    },
    {
        key: 'dedicated',
        label: `Dedicated EDMs`,
        searchEnum: NewsletterTypeEnum.DedicatedEdm,
    },
];

export const DigitalMagazineOptions = sortMagazineOptions(unsortedOptions);

export const BASE_URL = `/digital-magazines`;
export const FILTER_API_ENDPOINT = `/remix-api/digital-magazines/get-magazine-filters`;
export const START_YEAR = 2014;
